<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>
            <b-table
                :fields="fields"
                striped
                hover
                responsive
                :items="templates"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['type', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [
                {
                    key: 'id',
                    label: 'Actions',
                },
                'name',

                {
                    key: 'order_category_id',
                    label: 'Category',
                    formatter: (value, key, item) => item.category.name,
                },
                {
                    key: 'order_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.type.name,
                },
            ],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
}
</script>
<style></style>
